import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { TextButton } from "@src/appV2/redesign/components/TextButton";

interface ProofOfEarningsErrorBottomSheetProps {
  modalState: UseModalState;
  isRetryLoading?: boolean;
  onRetry: () => void;
}

export function ProofOfEarningsErrorBottomSheet(props: ProofOfEarningsErrorBottomSheetProps) {
  const { modalState, isRetryLoading = false, onRetry } = props;

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={modalState.closeModal} />}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth disabled={isRetryLoading} onClick={onRetry}>
            Try again
          </Button>
          <TextButton
            size="large"
            sx={{ marginTop: 1, marginBottom: 3 }}
            onClick={modalState.closeModal}
          >
            Close
          </TextButton>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="error"
        title="Email did not send"
        description="We couldn't send your proof of earnings. Please try again."
      />
    </BottomSheet>
  );
}
